<template>
  <div>
    <v-card>
      <gg-toolbar @close="closeModal">
        Change Password
      </gg-toolbar>

      <v-card-text class="pb-3">
        <compact-password outlined
                          label="Password"
                          v-validate="'required'"
                          data-vv-name="password"
                          data-vv-as="Password"
                          :error-messages="errors.collect('password')"
                          with-generator
                          v-model="model.password"></compact-password>
      </v-card-text>
      <v-card-actions class="justify-content-end pb-4 pr-4">
        <gg-btn secondary @click="closeModal">
          Cancel
        </gg-btn>
        <gg-btn primary :loading="query_loading" @click="setPassword">
          Save Changes
        </gg-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'ChangePassword',
  components: {
    CompactPassword
  },
  data: () => ({
    model: {
      password: '',
    },
    password: '',
    query_loading: false
  }),
  props: {
    email: {
      type: String,
      required: true
    },
    domain: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      changePassword: 'email/changePassword',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    listenPassword (payload) {
      this.password = payload
    },
    // Update password
    async setPassword () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      this.query_loading = true
      const params = {
        email: this.email,
        domain: this.domain,
        password: this.model.password,
        _username: this.$route.query.user
      }
      try {
        await this.changePassword(params)
        this.reportSuccess('Password was changed successfully!')

        this.closeModal()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.query_loading = false
      }
    },

    closeModal () {
      this.$emit('close')
    },
  },
  computed: {
    ...mapGetters(['hosting']),

    isFormValid () {
      return this.password !== ''
    }
  }
}
</script>
